var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { observable, action, computed } from 'mobx';
import debounce from 'lodash/debounce';
import { IMState } from "../interface/state-interface";
import imsdkUtil from '../imsdk';
import event from '../event';
import { UPDATE_ACTIVE_SESSION_START, UPDATE_ACTIVE_SESSION_SUCCESS, UPDATE_ACTIVE_SESSION_ERROR, CLEAR_INPUT, CHANGE_LIST, LOAD_MORE_MESSAGES_START, LOAD_MORE_MESSAGES_SUCCESS, LOAD_MORE_SESSION_START, LOAD_MORE_SESSION_SUCCESS } from '../event/constant';
var ImCoreState = (function () {
    function ImCoreState() {
        this.messageList = [];
        this.sessionList = [];
        this.emojiList = [];
        this.emojiGroup = [];
        this.quickReplyList = [];
        this.isUpdatingActiveSession = false;
        this.onLine = true;
        this.isConnecting = false;
        this.draftMap = new Map();
        this.isImLoading = true;
        this.isImError = false;
        this.notLogin = true;
        this.imState = IMState.loading;
        this.isMessageLoading = false;
        this.isMoreMessageLoading = false;
        this.isMoreSessionLoading = true;
        this.deletedIds = new Set();
        this.uploadProgress = 0;
        this.selectedFiles = null;
        this.inputMessage = '';
        window.addEventListener('online', this.setOnlineStatus);
        window.addEventListener('offline', this.setOnlineStatus);
        this.setDraft = debounce(this.setDraft, 200);
    }
    Object.defineProperty(ImCoreState.prototype, "currentDraft", {
        get: function () {
            var _a = this, activeSessionId = _a.activeSessionId, draftMap = _a.draftMap;
            return activeSessionId ? draftMap.get(activeSessionId) : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImCoreState.prototype, "activeSessionId", {
        get: function () {
            return this.activeSession ? this.activeSession.sessionId : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImCoreState.prototype, "totalUnread", {
        get: function () {
            return (this.sessionList || []).reduce(function (prev, session) { return prev + session.nonReadNumber; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    ImCoreState.prototype.getEmitterParams = function () {
        var extraParams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extraParams[_i] = arguments[_i];
        }
        return __spread([{ store: this, im: imsdkUtil.getImInstance() }], extraParams);
    };
    ImCoreState.prototype.emit = function (name) {
        var extraParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraParams[_i - 1] = arguments[_i];
        }
        try {
            event.emit.apply(event, __spread([name], this.getEmitterParams.apply(this, __spread(extraParams))));
        }
        catch (e) {
            console.error(e);
        }
    };
    ImCoreState.prototype.updateData = function (data) {
        if (data === void 0) { data = {}; }
        for (var key in data) {
            this[key] = data[key];
        }
    };
    ImCoreState.prototype.updateActiveSession = function (activeSession, startTime, clearCache) {
        return __awaiter(this, void 0, void 0, function () {
            var im, sessionId, nonReadNumber, e_1, index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.emit(UPDATE_ACTIVE_SESSION_START, activeSession);
                        im = imsdkUtil.getImInstance();
                        if (!im)
                            return [2];
                        sessionId = activeSession ? (activeSession.sessionId || '') : -1;
                        nonReadNumber = activeSession.nonReadNumber || 0;
                        this.activeSession = activeSession;
                        this.isUpdatingActiveSession = true;
                        this.messageList = [];
                        this.isMessageLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, im.setConversationSession(sessionId, nonReadNumber, startTime, clearCache)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.emit(UPDATE_ACTIVE_SESSION_ERROR, activeSession);
                        this.isUpdatingActiveSession = false;
                        console.error(e_1);
                        return [2];
                    case 4:
                        index = (this.sessionList || []).findIndex(function (i) { return i.sessionId === sessionId; });
                        if (index > -1) {
                            this.sessionList[index].nonReadNumber = 0;
                        }
                        this.emit(UPDATE_ACTIVE_SESSION_SUCCESS, activeSession);
                        this.isUpdatingActiveSession = false;
                        this.emit(CLEAR_INPUT);
                        this.emit(CHANGE_LIST);
                        this.fetchMessageList();
                        return [2, activeSession];
                }
            });
        });
    };
    ;
    ImCoreState.prototype.updateMessage = function (inputList) {
        var _this = this;
        this.messageList = inputList.filter(function (i) { return !_this.deletedIds.has(i.messageId); });
    };
    ImCoreState.prototype.fetchMessageList = function () {
        var _this = this;
        var im = imsdkUtil.getImInstance();
        this.isMessageLoading = true;
        this.messageList = [];
        im.getMessageList(this.activeSessionId)
            .then(function (result) {
            _this.updateMessage(result);
            _this.updateData({ isMessageLoading: false });
            return result;
        });
    };
    ;
    ImCoreState.prototype.getMoreMessage = function (isDownward) {
        return __awaiter(this, void 0, void 0, function () {
            var im, result, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        im = imsdkUtil.getImInstance();
                        this.emit(LOAD_MORE_MESSAGES_START);
                        this.isMoreMessageLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, im.getMoreMessage(isDownward)];
                    case 2:
                        result = _a.sent();
                        return [3, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.isMoreMessageLoading = false;
                        throw e_2;
                    case 4:
                        this.isMoreMessageLoading = false;
                        this.updateMessage(result);
                        this.emit(LOAD_MORE_MESSAGES_SUCCESS);
                        return [2, result];
                }
            });
        });
    };
    ;
    ImCoreState.prototype.readNewMessage = function (msg) {
    };
    ;
    ImCoreState.prototype.receiveNewMessage = function () {
    };
    ;
    ImCoreState.prototype.loadMoreSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var im, sessionList, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        im = imsdkUtil.getImInstance();
                        this.emit(LOAD_MORE_SESSION_START);
                        this.isMoreSessionLoading = true;
                        sessionList = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, im.fetchMoreSession()];
                    case 2:
                        sessionList = _a.sent();
                        return [3, 4];
                    case 3:
                        e_3 = _a.sent();
                        this.isMoreSessionLoading = false;
                        throw e_3;
                    case 4:
                        this.emit(LOAD_MORE_SESSION_SUCCESS);
                        imsdkUtil.sessionListUpdate(sessionList);
                        return [2];
                }
            });
        });
    };
    ;
    ImCoreState.prototype.createSession = function (accountId, accountType, fromCode) {
        if (accountType === void 0) { accountType = 1; }
        if (fromCode === void 0) { fromCode = 'sc_seller_default'; }
        return __awaiter(this, void 0, void 0, function () {
            var im, session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        im = imsdkUtil.getImInstance();
                        if (!im) {
                            throw null;
                        }
                        return [4, im.createSession(accountId, accountType, fromCode)];
                    case 1:
                        session = _a.sent();
                        return [4, this.updateActiveSession(session)];
                    case 2:
                        _a.sent();
                        session.fromCode = fromCode;
                        return [2, session];
                }
            });
        });
    };
    ;
    ImCoreState.prototype.sendMessage = function (data) {
        var im = imsdkUtil.getImInstance();
        var templateType = data.templateType, templateData = data.templateData, ext = data.ext, messageId = data.messageId;
        this.setDraft('');
        return im.sendMessage(templateType, templateData, messageId, ext);
    };
    ;
    ImCoreState.prototype.deleteMessage = function (messageId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!messageId)
                    return [2];
                this.deletedIds.add(messageId);
                this.updateMessage(this.messageList);
                return [2];
            });
        });
    };
    ImCoreState.prototype.deleteSession = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var im;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!sessionId)
                            return [2];
                        im = imsdkUtil.getImInstance();
                        return [4, im.deleteSession(sessionId)];
                    case 1:
                        _a.sent();
                        this.resetSession(sessionId);
                        return [2];
                }
            });
        });
    };
    ImCoreState.prototype.resetSession = function (sessionId) {
        if (sessionId === this.activeSessionId) {
            this.activeSession = {};
            this.messageList = [];
        }
    };
    ImCoreState.prototype.removeDraft = function (sessionId) {
        if (sessionId === void 0) { sessionId = this.activeSessionId; }
        this.setDraft('', sessionId);
    };
    ImCoreState.prototype.setDraft = function (draft, sessionId) {
        if (sessionId === void 0) { sessionId = this.activeSessionId; }
        draft.trim() !== ''
            ? this.draftMap.set(sessionId, draft)
            : this.draftMap.delete(sessionId);
    };
    ImCoreState.prototype.setOnlineStatus = function () {
        this.onLine = window.navigator.onLine;
    };
    ImCoreState.prototype.fetchEmojiList = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.ImSDK.getEmojiList().then(function (res) {
                if (!res[0]) {
                    return resolve();
                }
                _this.updateData({
                    emojiGroup: res,
                    emojiList: res[0].list
                });
                return resolve(res);
            });
        });
    };
    ImCoreState.prototype.uploadFiles = function () {
        var _this = this;
        var files = this.selectedFiles;
        if (!files)
            return Promise.resolve();
        this.uploadProgress = 1;
        var inProgress = function (done, total) {
            _this.updateData({
                uploadProgress: done / total * 100 || 1,
            });
        };
        return this.ImSDK.uploadImg(files, inProgress);
    };
    ImCoreState.prototype.updateInputMessage = function (value) {
        var newMessage = typeof value === 'string' ? value : '';
        newMessage = newMessage.substring(0, 2000);
        this.inputMessage = newMessage;
    };
    ImCoreState.prototype.reUpdateInputMessage = function (value) {
        var newMessage = typeof value === 'string' ? value : '';
        newMessage = newMessage.substring(0, 2000);
        this.inputMessage += newMessage;
    };
    ImCoreState.prototype.messageWithdraw = function (messageId) {
        var im = imsdkUtil.getImInstance();
        im.messageWithdraw(messageId);
    };
    __decorate([
        observable
    ], ImCoreState.prototype, "messageList", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "sessionList", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "emojiList", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "emojiGroup", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "quickReplyList", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "activeSession", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "isUpdatingActiveSession", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "loginUser", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "onLine", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "isConnecting", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "draftMap", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "isImLoading", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "isImError", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "notLogin", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "imState", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "isMessageLoading", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "isMoreMessageLoading", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "isMoreSessionLoading", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "deletedIds", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "uploadProgress", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "selectedFiles", void 0);
    __decorate([
        observable
    ], ImCoreState.prototype, "inputMessage", void 0);
    __decorate([
        computed
    ], ImCoreState.prototype, "currentDraft", null);
    __decorate([
        computed
    ], ImCoreState.prototype, "activeSessionId", null);
    __decorate([
        computed
    ], ImCoreState.prototype, "totalUnread", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "updateData", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "updateActiveSession", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "updateMessage", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "fetchMessageList", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "getMoreMessage", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "loadMoreSession", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "createSession", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "deleteMessage", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "deleteSession", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "resetSession", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "removeDraft", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "setDraft", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "setOnlineStatus", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "fetchEmojiList", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "uploadFiles", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "updateInputMessage", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "reUpdateInputMessage", null);
    __decorate([
        action.bound
    ], ImCoreState.prototype, "messageWithdraw", null);
    return ImCoreState;
}());
export default ImCoreState;
